// src/pages/Register/Register.js

import React, {useState} from 'react';
import {useNavigate, Link} from 'react-router-dom';
import api from '../../services/api';  // <-- Import your axios instance
import './Register.css';

const Register = () => {
    const navigate = useNavigate();

    // Form fields
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPass, setConfirmPass] = useState('');

    // UI feedback
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    // Before: Register.js
    // After: Register.js
    const handleRegister = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (!username || !password) {
            setError('Username and password are required.');
            return;
        }
        if (password !== confirmPass) {
            setError('Passwords do not match.');
            return;
        }

        try {
            // No need to assign to a variable if you don't use it.
            await api.post('/auth/register', { username, password });

            setSuccess('Registration successful! Redirecting to login...');
            setTimeout(() => {
                navigate('/login');
            }, 1500);
        } catch (err) {
            if (err.response && err.response.data?.error) {
                setError(err.response.data.error);
            } else {
                setError(err.message || 'Registration failed ');
            }
        }
    };



    return (
        <div className="register-container">
            <form onSubmit={handleRegister} className="register-box">
                <h2>Register</h2>

                {error && <p className="register-error">{error}</p>}
                {success && <p className="register-success">{success}</p>}

                <label>Username</label>
                <input
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />

                <label>Password</label>
                <input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <label>Confirm Password</label>
                <input
                    type="password"
                    placeholder="Confirm password"
                    value={confirmPass}
                    onChange={(e) => setConfirmPass(e.target.value)}
                />

                <button type="submit" className="register-btn">Sign Up</button>

                <div className="switch-auth-link">
                    <p>
                        Already have an account? <Link to="/login">Log In</Link>
                    </p>
                </div>
            </form>
        </div>
    );
};

export default Register;
